import React from "react";
import Grid from "@mui/material/Grid2"; 
import { Box, Typography, Card } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { PolicyOrAccount } from "../../../../interfaces/DTO/mislaka_xml_models";
import { PensionFundCoverage } from "../../../../interfaces/DTO/mislaka_xml_insurence_models";
import { formatCurrency, formatPercentage } from "../../../../utils/namesFormater";

interface PensionFundCoverageSummaryProps {
  policies: PolicyOrAccount[];
}

const PensionFundCoverageSummary: React.FC<PensionFundCoverageSummaryProps> = ({ policies }) => {
  // שליפת כל הכיסויים הפנסיוניים מכל הפוליסות
  const allPensionCoverages: PensionFundCoverage[] = policies.flatMap(policy =>
    policy.insurence_coverages?.flatMap(coverage => coverage.coverages || []) || []
  );

  if (allPensionCoverages.length === 0) return null;

  // חישוב נתוני סיכום
  const definingSalary = allPensionCoverages.find(cov => cov.defining_salary)?.defining_salary || 0;
  const totalDisabilityPension = allPensionCoverages.find(cov => cov.total_disability_pension)?.total_disability_pension || 0;
  const totalWidowPension = allPensionCoverages.find(cov => cov.widow_pension_amount)?.widow_pension_amount || 0;
  const totalOrphanPension = allPensionCoverages.find(cov => cov.orphan_pension_amount)?.orphan_pension_amount || 0;
  const totalParentSupportPension = allPensionCoverages.find(cov => cov.parent_support_pension_amount)?.parent_support_pension_amount || 0;

  const disabilityCoverageRate = allPensionCoverages.find(cov => cov.disability_coverage_rate)?.disability_coverage_rate || 0;
  const widowCoverageRate = allPensionCoverages.find(cov => cov.widow_coverage_rate)?.widow_coverage_rate || 0;
  const orphanCoverageRate = allPensionCoverages.find(cov => cov.orphan_coverage_rate)?.orphan_coverage_rate || 0;
  const parentSupportCoverageRate = allPensionCoverages.find(cov => cov.parent_support_coverage_rate)?.parent_support_coverage_rate || 0;

  return (
    <Box sx={{ mt: 3 }}>
      {/* כותרת ראשית */}
      <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
        שכר קובע לכיסוי נכות ושאירים: {formatCurrency(definingSalary)}
      </Typography>

      {/* קוביות סיכום */}
      <Grid container spacing={2}>
        {/* כיסוי נכות */}
        <Grid size={{ xs: 12, md: 3 }}>
          <Card sx={{ p: 2, backgroundColor: "#8e44ad", color: "white", textAlign: "center" }}>
            <Typography variant="body2" fontWeight="bold">שיעור כיסוי נכות</Typography>
            <Typography variant="h6">{formatPercentage(disabilityCoverageRate)}</Typography>
            <ArrowForwardIcon sx={{ fontSize: 30 }} />
            <Typography variant="body2" fontWeight="bold">סך פנסיית נכות</Typography>
            <Typography variant="h6">{formatCurrency(totalDisabilityPension)}</Typography>
          </Card>
        </Grid>

        {/* כיסוי אלמן/ה */}
        <Grid size={{ xs: 12, md: 3 }}>
          <Card sx={{ p: 2, backgroundColor: "#2c3e50", color: "white", textAlign: "center" }}>
            <Typography variant="body2" fontWeight="bold">שיעור כיסוי אלמן/ה</Typography>
            <Typography variant="h6">{formatPercentage(widowCoverageRate)}</Typography>
            <ArrowForwardIcon sx={{ fontSize: 30 }} />
            <Typography variant="body2" fontWeight="bold">סך פנסיית אלמן/ה</Typography>
            <Typography variant="h6">{formatCurrency(totalWidowPension)}</Typography>
          </Card>
        </Grid>

        {/* כיסוי יתום */}
        <Grid size={{ xs: 12, md: 3 }}>
          <Card sx={{ p: 2, backgroundColor: "#27ae60", color: "white", textAlign: "center" }}>
            <Typography variant="body2" fontWeight="bold">שיעור כיסוי יתום</Typography>
            <Typography variant="h6">{formatPercentage(orphanCoverageRate)}</Typography>
            <ArrowForwardIcon sx={{ fontSize: 30 }} />
            <Typography variant="body2" fontWeight="bold">סך קצבת יתום</Typography>
            <Typography variant="h6">{formatCurrency(totalOrphanPension)}</Typography>
          </Card>
        </Grid>

        {/* כיסוי הורה נתמך */}
        <Grid size={{ xs: 12, md: 3 }}>
          <Card sx={{ p: 2, backgroundColor: "#d35400", color: "white", textAlign: "center" }}>
            <Typography variant="body2" fontWeight="bold">שיעור כיסוי הורה נתמך</Typography>
            <Typography variant="h6">{formatPercentage(parentSupportCoverageRate)}</Typography>
            <ArrowForwardIcon sx={{ fontSize: 30 }} />
            <Typography variant="body2" fontWeight="bold">סך פנסיית הורה נתמך</Typography>
            <Typography variant="h6">{formatCurrency(totalParentSupportPension)}</Typography>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PensionFundCoverageSummary;
